/**
 * Register the Zoneium PWA service worker.
 * Called once from main.tsx on app bootstrap.
 */
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  if (import.meta.env.DEV) return; // skip in dev — HMR interferes

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        // Check for updates every 60 minutes
        setInterval(() => {
          registration.update().catch(() => {});
        }, 60 * 60 * 1000);
      })
      .catch((err) => {
        // Non-fatal — app still works without SW
        // eslint-disable-next-line no-console
        console.warn('[Zoneium] Service worker registration failed:', err);
      });
  });
}
